<style scoped>
	/*btn-prover*/
	.btn {
	  width: 88px;
	  height: 30px;
	  line-height: 30px;
	  margin-right: 10px;
	  color: #666666;
	  border: 1px solid rgba(204, 204, 204, 1);
	  cursor: pointer;
	  position: relative;
	  text-align: center;
	}

	.blue-btn {
	  background: linear-gradient(0deg, rgba(63, 159, 234, 1) 0%, rgba(10, 119, 206, 1) 100%);
	  border: none;
	  color: #ffffff;
	}
	.btn-prover>.third-icon{
	  width: 0;
	  height: 0;
	  border-bottom: 5px solid transparent;
	  border-top: 10px solid #ffffff;
	  border-left: 5px solid transparent;
	  border-right: 5px solid transparent;
	  margin: -3px 0 0 10px;
	}
	.btn-prover{
	  position: absolute;
	  top: -75px;
	  left: 0;
	  width: 88px;
	  height: 105px;
	  display: none;
	}
	.a123:hover .btn-prover{
	  display: block;
	}

	.btn-prover>.btn-prover-content{
	  height: 60px;
	  box-shadow: 0 0 20px 2px #dcdfe6;
	  border-radius: 5px;
	  background: #FFFFFF;
	}
	.btn-prover>.btn-prover-content>.download:hover{
	  color:#26AFFD;
	}
	.btn-prover>.third-icon{
	  width: 0;
	  height: 0;
	  border-bottom: 5px solid transparent;
	  border-top: 10px solid #ffffff;
	  border-left: 5px solid transparent;
	  border-right: 5px solid transparent;
	  margin: -3px 0 0 10px;
	}
	.main-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 100vh;
}

.main-order-box {
  flex: 1;
  margin-bottom: 60px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 7px 11px 0 rgba(231, 231, 231, 0.7);
  border-radius: 3px;
}

/* 订单 类型 */

.order-type {
  display: flex;
  height: 60px;
  border-bottom: 1px solid rgba(204, 204, 204, 0.41);
}

.order-type > .item {
  color: #666666;
  cursor: pointer;
  line-height: 60px;
  margin: 0 20px;
}

.order-type > .item.checked-type {
  border-bottom: 1px solid #000000;
  color: #000000;
}

.item {
  display: inline-block;
  font-size: 14px;
}

/* 订单状态 */
.order-state {
  color: #4a4a4a;
  height: 32px;
  margin: 20px 0;
  /* display: flex; */
  text-align: left;
}

.order-state > .item:nth-child(1) {
  margin-left: 10px;
}

.order-state > .item {
  padding: 0 10px;
  line-height: 32px;
  margin: 0 10px;
}

.order-state > .item.checked-state {
  color: #fff;
  background: #0f7bd0;
}

/* order-list  */
.order-list {
  margin: 0 20px;
}

.table {
  /*width: 825px;*/
  border: 1px solid #e2e2e2;
}

.goods-name {
  font-size: 14px;
  color: #333;
  line-height: 40px;
}

.goods-msg {
  height: 116px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e2e2e2;
  box-sizing: border-box;
  text-align: left;
}

.goods-msg:last-child {
  border: 0;
}

.table-title {
  background: #e2e2e2;
  height: 40px;
  text-align: left;
  display: flex;
}

.width362 {
  width: 362px;
}

.fir-name {
  padding-left: 137px;
}

.se-name {
  width: 158px;
}

.th-name {
  width: 111px;
}

.la-name {
  /*width: 180px;*/
}

.goods-img {
  width: 137px;
}

.goods-img-box {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-bottom: 8px;
}

.goods-img-box img{
	width: 100%;
	height: 100%;
}

.goods-detail {
  /*width: 225px;*/
}

.font1 {
  font-size: 18px;
  color: #000;
  margin-bottom: 16px;
  width: 95%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.font2 {
  font-size: 14px;
  color: #666;
  width: 95%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.goods-price {
  font-size: 18px;
  color: #d03b3b;
  font-weight: bold;
  width: 158px;
}

.goods-name.la-name {
  text-align: center;
}

.goods-state {
  width: 111px;
  color: #137ed3;
}

.goods-state.color {
  color: #d03b3b;
}

.goods-btn {
  display: flex;
  width: 400px;
  flex-wrap: wrap;
}

.goods-btn > a {
  width: 88px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  margin-bottom: 10px;
  margin-right: 10px;
}

.pay {
  background-image: linear-gradient(#3f9fea, #0a77ce);
  color: #fff;
}

.dele-order {
  background: #fff;
  border: 1px solid #0a77ce;
  box-sizing: border-box;
}

/*分页*/
.page-component {
  height: 70px;
  border: 1px solid rgba(226, 226, 226, 1);
  margin: 30px 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

/***** *  customized-order定制订单列表样式    * *****/
.customized-order {
  margin: 0 20px;
  min-height: 100px;
}

/* model  */

.model-content {
  width: 400px;
  height: 400px;
  box-shadow: 0 0 20px 2px #999999;
  border-radius: 5px;
  background: #ffffff;
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.content-content {
  flex: 1;
  font-size: 20px;
/*  line-height: 80px; */
margin-top: 20px;
}

.btn-button {
  margin: 10px 20px 20px 0;
  display: flex;
  justify-content: flex-end;
}

/*none-data*/
.none-data {
  font-size: 18px;
  color: #999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.inp{
	width: 60% !important;
	margin-left: 20px;
}
.t_title{
	font-size: 16px;
}

</style>

<template>
	<div class="main-content">
		<WNav></WNav>
		<Back></Back>
		<div class="main-order-box word">
			<!--type and state-->
			<div class="order-type" @click="orderTypeChange">
				<div class="item" v-for="(item , index) in typeList" data-type="type" :data-index="index" :class="checkedTypeIndex === index ? 'checked-type' : ''"
				 :key="index">{{item}}</div>
			</div>
			<div class="order-state" @click="orderTypeChange">
				<div class="item" v-for="(item , index) in stateList[checkedTypeIndex]" data-type="state" :data-index="index"
				 :class="checkedStateIndex == index ? 'checked-state' : ''" :key="index">{{item.text}}</div>
			</div>
			<!--type and state end-->
			<div class="order-list table" v-if="checkedTypeIndex !== 2">
				<div class="table-title">
					<div class="goods-name fir-name width362">{{$t('order.information')}}</div>
					<div class="goods-name se-name">{{$t('order.Price')}}{{checkedTypeIndex === 1 ? $t('order.integral') : ''}}</div>
					<div class="goods-name th-name">{{$t('order.state')}}</div>
					<div class="goods-name la-name">{{$t('order.edit')}}</div>
				</div>

				<div class="goods-msg" v-if="orderList.length > 0" v-for="(item,index) in orderList" :key="index">
					<div class="goods-img">
						<div class="goods-img-box" v-if="checkedTypeIndex === 0">
							<img :src="item.productImg?item.productImg.split(',')[0]:''" />
						</div>
						<div class="goods-img-box" v-if="checkedTypeIndex === 1">
							<img :src="item.params ? item.params.productImg.split(',')[0] : ''" />
						</div>
						<div class="goods-img-box" v-if="checkedTypeIndex === 2">
							<img src="@/assets/images/pro.png" />
						</div>
					</div>

					<div class="goods-detail">
						<!-- 成品 -->
						<div class="width362" v-if="checkedTypeIndex === 0">
							<div class="font1">{{item.productName}}</div>
							<div class="font2">{{$t('order.number')}}：{{item.orderNo}}</div>
							<div class="font2">{{$t('order.num')}}： {{item.num ? item.num : 0}}</div>
						</div>
						<!-- 样品 -->
						<div class="width362" v-if="checkedTypeIndex === 1">
							<div class="font1">{{item.params ? item.params.productName : ''}}</div>
							<div class="font2">{{$t('order.number')}}：{{item.orderNo}}</div>
							<div class="font2">{{$t('order.num')}}： 1</div>
						</div>
						<!-- 定制 -->
						<div class="width362" v-if="checkedTypeIndex === 2">
							<div class="font1">{{item.productName}}</div>
							<div class="font2">{{$t('order.number')}}：{{item.orderNo}}</div>
							<div class="font2">{{$t('order.num')}}： {{item.demandQuantity}}</div>
						</div>
					</div>

					<!-- 成品 -->
					<div class="goods-price" v-if="checkedTypeIndex === 0">{{`${$type == 1?'￥':'$'}` + (item.moneyNum / 100)}}</div>
					<div class="goods-state" :class="item.proOrderState === 1 ? 'color' : ''" v-if="checkedTypeIndex === 0">
						{{
				item.proOrderState === 1 ? $t('state.payment')
			: (item.proOrderState === 2 && (num == 2 || num == '') && item.assFlag !== 1 &&  item.assFlag !== 3 && item.assFlag !== 6)? $t('state.delivergoods')
            : (item.proOrderState === 3 && (num == 3 ||num == '') && item.assFlag !== 1 &&  item.assFlag !== 3)? $t('state.Distribution')
			: (item.proOrderState === 4 && (num == 4 || num == '')&& item.assFlag !== 1 &&  item.assFlag !== 3)? $t('state.Completed')
			: item.assFlag === 1 ? $t('order.exchange')
			: item.assFlag === 3 || item.assFlag === 6? $t('order.returngoods')
			: item.assFlag === 1 && (num == 6 || num == '')? $t('order.exchange')
			: item.assFlag === 3 && (num == 6 || num == '')? $t('order.returngoods')
			: item.assFlag === 2 && (num == 6 || num == '')? $t('order.hcomplete')
			: item.assFlag === 4 || item.assFlag === 7 && (num == 6 || num == '')? $t('order.tcomplete')
			: item.assFlag === 5 && (num == 6 || num == '')? $t('order.Rejected'):$t('order.Closed')
            }}
					</div>
					<div class="goods-btn" v-if="checkedTypeIndex === 0">
						<a href="javascript:void(0)" class="pay" v-if="item.proOrderState === 1" :data-idex="index" @click="linkToPay($event)">{{$t('order.payment')}}</a>
						<!-- <a href="javascript:void(0)" class="pay" v-if="item.proOrderState == 2 || item.proOrderState == 3 || item.proOrderState == 4 && item.assFlag == 0"
						 :data-idex="index" @click="uploadContract(item.orderNo)">{{$t('order.upcontract')}}</a> -->
						<div data-setval="5" class="btn blue-btn a123" v-if="(item.proOrderState == 2 || item.proOrderState == 3 || item.proOrderState == 4)&& (item.systemContract !== null || item.userContract !== null)">
							<span>{{$t('order.Dcontract')}}</span>
							<div class="btn-prover">
								<div class="btn-prover-content">
									<a :href="item.systemContract !== null?$img + item.systemContract.split(',')[1]:''" data-setbtn="1" class="download"
									 download v-if="item.systemContract !== null">{{$t('order.Gcontract')}}</a>
									<a :href="item.userContract !== null?$img + item.userContract.split(',')[1]:''" data-setbtn="2" class="download"
									 download v-if="item.userContract !== null">{{$t('order.Ycontract')}}</a>
								</div>
								<div class="third-icon"></div>
							</div>
						</div>
						<a href="javascript:void(0)" class="pay" v-if="item.proOrderState > 1 && item.proOrderState < 5 && item.assFlag == 0"
						 @click="apply(item.orderNo)">{{$t('order.Aftersales')}}</a>
						<a href="javascript:void(0)" class="pay" v-if="item.proOrderState > 1 && item.proOrderState < 5 && item.assFlag == 0 && item.invoiceFlag == 0"
						 @click="billing(item.orderNo)">{{$t('order.Billing')}}</a>
						<a href="javascript:void(0)" class="pay" @click="standardReceipt(item.orderNo)" v-if="item.proOrderState === 3 && item.assFlag == 0">{{$t('order.Confirmreceipt')}}</a>
						<a href="javascript:void(0)" class="dele-order" @click="cancelOrder(index , 'standard')" v-if="item.proOrderState < 2">{{$t('order.Corder')}}</a>
						<a href="javascript:void(0)" class="dele-order" @click="deleteOrder(item.orderNo)" v-if="item.proOrderState == 5 || item.proOrderState == 4">{{$t('order.deletes')}}</a>
						<a href="javascript:void(0)" class="dele-order" @click="det(item.orderNo)">{{$t('order.details')}}</a>

					</div>

					<!-- 样品 -->
					<div class="goods-price" v-if="checkedTypeIndex === 1">{{item.integralNum}}</div>
					<div class="goods-state" v-if="checkedTypeIndex === 1">
						{{
            item.orderState === 0 ? $t('state.toexamine') : item.orderState === 1 ? $t('state.delivergoods') : item.orderState === 2 ? $t('state.Receipt')
            :item.orderState === 3 ?$t('state.Receivedgoods') : item.orderState === 4 ? $t('state.Rejected') : $t('state.Cancelled')
            }}
					</div>
					<div class="goods-btn" v-if="checkedTypeIndex === 1">
						<a href="javascript:void(0)" class="dele-order" v-if="item.orderState > 2" @click="deleteOrder(item.orderNo)">{{$t('order.deletes')}}</a>
						<a href="javascript:void(0)" class="dele-order" @click="sampledet(item.orderNo)">{{$t('order.details')}}</a>
						<a href="javascript:void(0)" class="dele-order" @click="sampleReceiving(item.sampleId)" v-if="item.orderState === 2">{{$t('order.Confirmreceipt')}}</a>
					</div>

					<!-- 定制 -->
					<div class="goods-price" v-if="checkedTypeIndex === 2">{{`${$type == 1?'￥':'$'}` + (item.totalAmount ? item.totalAmount : 0)}}</div>
					<div class="goods-state" :class="item.orderState === 4 ? 'color' : ''" v-if="checkedTypeIndex === 2">
						{{
            item.orderState === 1 ? $t('state.upload') : item.orderState === 2 ? $t('state.htToexamine') : item.orderState === 3 ? $t('state.setup')
            :item.orderState === 4 ?$t('state.payment') :item.orderState === 5 ? $t('state.delivergoods') : item.orderState === 6 ?  $t('state.htreject')
            :item.orderState === 7 ?  $t('state.ddreject') :item.orderState === 8 ? $t('state.Completed') :item.orderState === 9 ? $t('state.Rejected') :$t('state.toexamine')
            }}
					</div>
					<div class="goods-btn" v-if="checkedTypeIndex === 2">
						<a href="javascript:void(0)" class="pay" v-if="item.orderState === 4">{{$t('order.payment')}}</a>
						<a href="javascript:void(0)" class="pay" v-if="item.orderState !== 9" @click="download">{{$t('order.Dcontract')}}</a>
						<a href="javascript:void(0)" class="dele-order" @click="deleteOrder()" v-if="item.orderState === 1 || item.orderState === 0">{{$t('order.Corder')}}</a>
					</div>
				</div>
				<div class="goods-msg none-data" v-if="orderList.length <= 0">{{$t('vip.available')}}...</div>
			</div>
			<div class="order-list customized-order" :class="orderList.length <= 0 ? 'none-data' : ''" v-if="checkedTypeIndex === 2">
				<template v-if="orderList.length <= 0">{{$t('vip.available')}}...</template>
				<CustomizedOrderItem @update-state="updateStateFn" @show-modal-fn="showModalFn" v-for="(item,index) in orderList"
				 :ref="'fn' + index" :index="index" :order-no="item.orderNo" :order-state="item.orderState" :send="item.send" :time="item.createTime"
				 :key="index" :assFlag="item.assFlag" :num="num" :backContract="item.backContract" :frontContract="item.frontContract"></CustomizedOrderItem>
			</div>
			<!--order list end-->
			<div class="page-component">
				<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
				 :total="totalDataCounts"></el-pagination>
			</div>
		</div>
		<!-- 	开票 -->
		<el-dialog :title="$t('order.ApplyBilling')" :visible.sync="flag" width="35%" style="text-align: left;" @close="close">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="165px" class="demo-ruleForm">
				<el-form-item :label="$t('order.BillingType')" prop="resource">
					<el-radio-group v-model="ruleForm.resource">
						<el-radio :label="$t('order.domesticBilling')"></el-radio>
						<el-radio :label="$t('order.abroadBilling')"></el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('order.corporatename')" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.taxpayer')" prop="num">
					<el-input v-model="ruleForm.num"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.address')" prop="city">
					<el-input v-model="ruleForm.city"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.tel')" prop="tel">
					<el-input v-model="ruleForm.tel"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.OpeningName')" prop="kf_name">
					<el-input v-model="ruleForm.kfhmc"></el-input>
				</el-form-item>
				<el-form-item :label="$t('order.OpeningAccount')" prop="kfhzh">
					<el-input v-model="ruleForm.kfhzh"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="submitForm('ruleForm')">{{$t('order.Applynow')}}</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<PayOkConfirm v-if="loadingPay" @click-emit-reload="clickBtn"></PayOkConfirm>
		<!-- 上传合同的模态框 -->
		<ModelPop v-if="showModel">
			<div class="model-content">
				<!--content box-->
				<div class="content-content">
					<!-- 上传合同input -->
					<el-upload class="upload-demo" drag accept=".doc, .docx, .pdf" action="/" :limit="1" :on-exceed="moreThanFile"
					 :on-remove="() => file = null" :http-request="e => file = e.file ">
						<i class="el-icon-upload"></i>
						<div class="el-upload__text">
							{{$t('order.up')}}
							<em>{{$t('order.clickUp')}}</em>
						</div>
						<div class="el-upload__tip" slot="tip">{{$t('order.upTxt')}}</div>
					</el-upload>
				</div>
				<!--底部按钮-->
				<div class="btn-button">
					<el-button type="primary" @click="fileUpload">{{$t('order.determine')}}</el-button>
					<el-button @click="() => showModel = false">{{$t('order.Cancel')}}</el-button>
				</div>
			</div>
		</ModelPop>
		<el-dialog :title="$t('order.Applysales')" :visible.sync="dialogVisible" width="30%" @close="close">
			<div class="flex_center" style="margin-bottom: 10px;">
				<div class="t_tittle">{{$t('order.AftersalesType')}}:</div>
				<el-select v-model="value" :placeholder="$t('order.Pleaseselect')" class="inp" @change="type" clearable>
					<el-option v-for="item in options" :key="item.value" :label="dialogVisible?item.label:''" :value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="flex_center">
				<div class="t_tittle">{{$t('order.AftersalesReason')}}:</div>
				<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" :placeholder="$t('order.Pleaseselect')" v-model="textarea"
				 class="inp">
				</el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{$t('order.Cancel')}}</el-button>
				<el-button type="primary" @click="determine">{{$t('order.determine')}}</el-button>
			</span>
		</el-dialog>
		<FooterModel></FooterModel>
	</div>

</template>

<script>
	import Back from "../../assembly/Back";
	import WNav from "../../assembly/WhiteNav";
	import FooterModel from "../../assembly/Footer";
	import CustomizedOrderItem from "./CustomizedOrderItem";
	import utils from "../../../assets/js/utils";
	import ModelPop from "../../assembly/ModelPop";
	import PayOkConfirm from "../../assembly/PayOkConfirm";
	import {
		Loading
	} from 'element-ui';

	export default {
		name: "AllOrder",
		components: {
			Back,
			WNav,
			FooterModel,
			CustomizedOrderItem,
			ModelPop,
			PayOkConfirm
		},
		data() {
			return {
				// 申请开票
				flag: false,
				ruleForm: {
					resource: '',
					name: '',
					num: "",
					city: "",
					tel: "",
					kfhmc: "",
					kfhzh: "",
				},
				rules: {},
				orderNo: "",
				serviceType: "",
				textarea: "",
				options: [],
				value: '',
				dialogVisible: false,
				//type
				typeList: [],
				checkedTypeIndex: 0,
				//state
				stateList: [],
				checkedStateIndex: 1,
				orderList: [],
				//page er
				totalDataCounts: 0,
				pageNum: 1,
				load: [],
				currentPage: 1,
				pageSize: 5,
				loadingPay: false,
				//成品订单上传合同
				showModel: false,
				file: null,
				num: "",
				show: false,
				modify: false
			};
		},
		mounted() {
			this.checkedStateIndex = this.$route.query.num ? this.$route.query.num : 1
			this.token = sessionStorage.getItem("token");
			this.loadData(0, 1, this.$route.query.num ? this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state : '');
			this.typeList = this.$t('order.typeList')
			this.stateList = this.$t('order.stateList')
			this.rules = this.$t('order.rules')
			this.options = this.$t('order.options')
			this.billingRecord()
		},
		methods: {
			// 删除订单
			deleteOrder(orderNo) {
				let url = this.checkedTypeIndex == 0 ? '/api/standard/order/del/order' : '/api/order/del/order'
				let data = {
					orderNo : orderNo,
					token: sessionStorage.getItem('token'),
				}
				this.$confirm(this.$t('order.tip'), this.$t('order.confirmTip'))
					.then(() => {
						this.$post(url, data).then(res => {
							if (res.code === 0) {
								this.loadData(
									this.checkedTypeIndex,
									this.currentPage,
									this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
								);
								this.$message({
									type: "success",
									message: this.$t('order.cancelOk')
								});
							}

						});
					})
					.catch(() => {

					});

			},
			// 获取开票记录
			billingRecord() {
				let url = 'api/invoice/list/new/one'
				this.$get(url, {
					token: sessionStorage.getItem('token'),
				}).then(res => {
					if (res.code == 0 && res.data) {
						res.data.invoiceInfo = JSON.parse(res.data.invoiceInfo)
						res.data.invoiceInfo.resource = res.data.invoiceType == 1 ? '国内开票' : '国外开票'
						this.ruleForm = res.data.invoiceInfo
					}
				});
			},
			// 上传合同
			uploadContract(e) {
				this.orderNo = e
				this.showModel = true
			},
			// 关闭弹框
			close() {
				this.ruleForm.resource = ''
				this.ruleForm.name = ''
				this.ruleForm.num = ''
				this.ruleForm.city = ''
				this.ruleForm.tel = ''
				this.ruleForm.kfhmc = ''
				this.ruleForm.kfhzh = ''
				this.textarea = ''
				this.value = ''
			},
			// 样品收货
			sampleReceiving(id) {
				let url = '/api/order/cancel/simple/order'
				let data = {
					sampleId: id,
					token: sessionStorage.getItem('token'),
					type: 3
				}
				this.$post(url, data).then(res => {
					if (res.code === 0) {
						this.loadData(
							this.checkedTypeIndex,
							this.currentPage,
							this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
						);
						this.$message({
							type: "success",
							message: this.$t('Tips.Receiptsuc')
						});
					}

				});
			},
			// 成品订单收货
			standardReceipt(id) {
				let url = '/api/standard/order/confirm/receipt'
				let data = {
					orderNo: id,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code === 0) {
						this.loadData(
							this.checkedTypeIndex,
							this.currentPage,
							this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
						);
						this.$message({
							type: "success",
							message: this.$t('Tips.Receiptsuc')
						});
					}

				});
			},
			// 成品订单详情
			det(orderNo) {
				this.$router.push(`/order/orderDetail?id=${orderNo}&num=${this.num}&type=0`);
			},
			// 样品订单详情
			sampledet(orderNo) {
				this.$router.push(`/order/orderDetail?id=${orderNo}&num=${this.num}&type=2`);
			},
			billing(e) {
				this.flag = true
				this.orderNo = e
			},
			// 开票
			submitForm(formName) {
				console.log(this.ruleForm)
				this.$refs[formName].validate((valid, obj) => {
					if (valid) {
						let val = {
							name: this.ruleForm.name,
							num: this.ruleForm.num,
							city: this.ruleForm.city,
							tel: this.ruleForm.tel,
							kfhmc: this.ruleForm.kfhmc,
							kfhzh: this.ruleForm.kfhzh,
						}
						let url = '/api/invoice/apply'
						let data = {
							orderNo: this.orderNo,
							invoiceType: this.ruleForm.resource == '国内开票' ? 1 : 2,
							orderType: 1,
							invoiceInfo: JSON.stringify(val),
							token: sessionStorage.getItem('token')
						}
						this.$post(url, data).then(res => {
							this.flag = false
							if (res.code == 0) {
								this.$message({
									message: this.$t('Tips.Billingsuc'),
									type: 'success'
								});
								this.loadData(
									this.checkedTypeIndex,
									this.currentPage,
									this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
								);
							}
						});
					} else {
						return false;
					}
				});
			},
			// 申请售后
			apply(e) {
				this.orderNo = e
				this.dialogVisible = true
			},
			// 售后类型
			type(e) {
				this.serviceType = e
			},
			// 确认售后
			determine() {
				if (this.serviceType == '') {
					this.$message({
						message: this.$t('Tips.Aftersalestype'),
						type: 'warning'
					});
					return false
				}
				if (this.textarea == '') {
					this.$message({
						message: this.$t('Tips.Aftersalesdescription'),
						type: 'warning'
					});
					return false
				}
				let token = sessionStorage.getItem('token')
				let that = this;
				let url = `/api/back/service/add`;
				let data = {
					orderType: 1,
					orderNo: this.orderNo,
					questionContent: this.textarea,
					serviceType: this.serviceType,
					token: token
				}
				this.$post(url, data).then(res => {
					this.textarea = ''
					this.dialogVisible = false
					if (res.code == 0) {
						this.$message({
							message: this.$t('Tips.applysuc'),
							type: 'success'
						});
						this.loadData(
							this.checkedTypeIndex,
							this.currentPage,
							this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
						);
					}
				});
			},
			//支付成功与否的反馈
			clickBtn() {
				this.loadingPay = false
				this.loadData(
					this.checkedTypeIndex,
					this.pageNum,
					this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
				);
				if (this.checkedTypeIndex == 2) {
					for (let i = 0; i < this.orderList.length; i++) {
						this.$refs["fn" + i][0].closeAndOpen &&
							this.$refs["fn" + i][0].closeAndOpen();
					}
				}
			},
			showModalFn() {
				this.loadingPay = true;
			},
			//切换页码
			handleCurrentChange(val) {
				this.currentPage = val;
				this.loadData(
					this.checkedTypeIndex,
					val,
					this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
				);
			},
			updateStateFn(e) {
				this.loadData(
					this.checkedTypeIndex,
					1,
					this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
				);
				for (let i = 0; i < this.orderList.length; i++) {
					this.$refs["fn" + i][0].closeAndOpen &&
						this.$refs["fn" + i][0].closeAndOpen();
				}
			},
			//自定义上传
			fileUpload() {
				let loading = Loading.service({
					lock: true,
					background: "rgba(0, 0, 0, 0)",
					text: this.$t("customizedApply.uploadFile")
				});
				let formData = new FormData();
				formData.append("file", this.file);
				formData.append('token', sessionStorage.getItem('token'));
				this.$fileUpload({
					url: "/open/upload/file",
					data: formData
				}).then(res => {
					//文件上传成功后提交其他数据
					loading.close();
					if (res.code === 0) {
						let url = res.data;
						//开始提交合同到后台
						this.$post("api/standard/order/upload/contract", {
							token: this.token,
							orderNo: this.orderNo,
							contractLink: this.file.name + "," + url
						}).then(res1 => {
							if (res1.code === 0) {
								this.$message({
									type: "success",
									message: this.$t('Tips.uploadsuc')
								});
								this.showModel = false;
								this.loadData(
									this.checkedTypeIndex,
									this.pageNum,
									this.stateList[this.checkedTypeIndex][this.checkedStateIndex]
									.state
								);
							}
						});
					}
				});
			},
			//文件超出限制个数时触发
			moreThanFile() {
				this.$message({
					type: "warning",
					message: this.$t('Tips.upTips')
				});
			},

			//订单类型切换
			orderTypeChange(e) {
				let index = Number(e.target.dataset["index"]);
				if (isNaN(index)) return;
				switch (e.target.dataset["type"]) {
					case "type":
						{
							if (
								this.checkedTypeIndex === index ||
								index < 0 ||
								index >= this.typeList.length
							)
								break;
							this.currentPage = 1;
							this.loadData(index, 1);
							//初始化当前选择状态下的数据
							this.checkedTypeIndex = index;
							this.checkedStateIndex = 1;
						}
						break;
					case "state":
						{

							if (

								this.checkedStateIndex === index ||
								index <= 0 ||
								index >= this.stateList[this.checkedTypeIndex].length
							)
								break;
							this.checkedStateIndex = index;
							if (this.checkedTypeIndex == 2) {
								for (let i = 0; i < this.orderList.length; i++) {
									this.$refs["fn" + i][0].closeAndOpen &&
										this.$refs["fn" + i][0].closeAndOpen();
								}
							}
							//加载数据，初始化页码
							this.currentPage = 1;
							this.loadData(
								this.checkedTypeIndex,
								1,
								this.stateList[this.checkedTypeIndex][index].state
							);
							this.num = String(this.stateList[this.checkedTypeIndex][index].state)
						}
						break;
				}
			},
			//加载数据
			loadData(index, pageNum, state = "") {
				let url =
					index === 0 ?
					"api/standard/order/list" :
					index === 1 ?
					"api/order/query/simple/order" :
					"api/customized/order/list";
				this.$get(url, {
					token: this.token,
					pageSize: this.pageSize,
					pageNum,
					state
				}).then(res => {
					if (res.code === 0) {
						let data = res.data;
						if (index === 2) {
							data.map((item, index1) => {
								item.createTime = utils.formatStringDate(
									item.createTime,
									"yyyy-MM-dd"
								);
								if (index1 < this.orderList.length) {
									this.$refs["fn" + index1] &&
										this.$refs["fn" + index1][0].changeLoadState();
								}
								return item;
							});
							this.load = new Array(data.length);
						}
						this.orderList = data;
						this.totalDataCounts = res.params.totalDataCounts;
						return;
					}
				});
			},
			//取消订单
			cancelOrder(index = -1, type = "") {
				this.$confirm(this.$t('order.Cancelpayment'), this.$t('customizedApply.title'))
					.then(() => {
						this.cancelOrderImplements(index, type);
					})
					.catch(() => {

					});
			},
			//取消订单的方法实现
			cancelOrderImplements(index = -1, type = "") {
				let url, data;
				if (type === "standard") {
					url = "api/standard/order/cancel/order";
					data = {
						orderNo: this.orderList[index].orderNo,
						token: this.token
					};
				} else if (type === "sample") {
					url = "api/order/cancel/simple/order";
					data = {
						sampleId: this.orderList[index].sampleId,
						token: this.token,
						type: 5
					};
				}
				if (!data || !url) return;
				this.$post(url, data).then(res => {
					if (res.code === 0) {
						this.$message({
							type: "success",
							message: this.$t('Tips.qxsuc')
						});
						this.loadData(
							this.checkedTypeIndex,
							this.currentPage,
							this.stateList[this.checkedTypeIndex][this.checkedStateIndex].state
						);
						return;
					}
					this.$message({
						type: "warning",
						message: this.$t('project.cancelErr')
					});
				});
			},
			//立即付款的实现
			linkToPay(e) {
				let idex = Number(e.target.dataset["idex"]);
				if (isNaN(idex) || idex >= this.orderList.length) return;
				// return;
				let data = this.orderList[idex];
				this.$confirm(this.$t('order.title'), this.$t('customizedApply.title'))
					.then(() => {
						//组装数据传入支付页面
						let routerData = {
							payAmount: data.moneyNum,
							zhMoney: data.moneyNumZh,
							orderNo: data.orderNo,
							pageName: this.$t('vip.finished'),
							orderType: 0 //成品订单
						};
						//显示弹窗
						this.showModalFn();
						sessionStorage.setItem("paydatainfo", JSON.stringify(routerData));
						let routerLinkData = this.$router.resolve({
							path: "/payPage"
						});
						window.open(routerLinkData.href, "_blank");
					})
					.catch(res => {
						console.log(res, "取消支付");
					});
				e.cancelBubble = true;
			},
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/order/AllOrder.vue